import React, { createContext, useContext, useState } from "react";

const DeepLinkMeetingContext = createContext({
  deepLinkMeetingId: null,
  setDeepLinkMeetingId: () => {},
  clearDeepLinkMeetingId: () => {},
});

export const DeepLinkMeetingProvider = ({ children }) => {
  const [deepLinkMeetingId, setDeepLinkMeetingId] = useState(null);

  const clearDeepLinkMeetingId = () => setDeepLinkMeetingId(null);

  return (
    <DeepLinkMeetingContext.Provider
      value={{ deepLinkMeetingId, setDeepLinkMeetingId, clearDeepLinkMeetingId }}
    >
      {children}
    </DeepLinkMeetingContext.Provider>
  );
};

export const useDeepLinkMeeting = () => useContext(DeepLinkMeetingContext);
